import { UserLocation } from "@nova/schemas"
import { createExternalStore, createExternalValue } from "@nova/toolkit-pure-hooks"

const store = createExternalStore<UserLocation>()
const usersSharingLocationKey = createExternalValue("")

const syncUsersSharingLocationKey = () =>
    usersSharingLocationKey.set([...store.get().keys()].sort().join(","))

export const orgUserLocationStore = {
    push: (location: UserLocation) => {
        store.set(location.userId, location)
        syncUsersSharingLocationKey()
    },
    replaceAll: (locations: UserLocation[]) => {
        store.replaceAll(locations, (l) => l.userId)
        syncUsersSharingLocationKey()
    },
    remove: (userId: string) => {
        store.remove(userId)
        syncUsersSharingLocationKey()
    },
    flush: () => {
        store.flush()
        syncUsersSharingLocationKey()
    },
    get: store.get,
    getUsersSharingLocationKey: usersSharingLocationKey.get,
}

export const useOrgUserLocations = store.useAll
export const useOrgUserLocation = store.useItem
export const useOrgUsersSharingLocationKey = usersSharingLocationKey.use
